var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn demand-share-btn",on:{"click":_vm.onClick}},[_c('icon-base',{attrs:{"icon-name":"truck","width":"24","height":"24","viewbox":"0 0 24 24"}},[_c('icon-share')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }